import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types";
import { PolicyFilterRequest } from "./PolicyFilter.types";

export interface PolicyRowModel {
    name: string;
    type: PolicyType;
    responsible?: string;
    responsibleId?: string;
    numberOfProcessingActivities: number;
    numberOfSystems: number;
    id: string;
    tags: Array<string>;
}

export interface PolicyRowModelTableModel extends PolicyRowModel {
    typeString: string;
}

export enum PolicyType {
    Policy = 100,
    Procedure = 101,
    Instruction = 102,
    Guideline = 103,
    Standard = 104,
    Plan = 105,
    Other = 106,
}

export interface PolicyLegacySaveModel {
    id: string;
    name: string;
    responsibleId: string | undefined | null;
    type?: PolicyType;
    tags: Array<string>;
}

export interface SelectablePolicyItem {
    id: string;
    name: string;
    type: PolicyType;
}

export interface PolicyTemplateViewModel {
    name: string;
    danishVersionFileName: string | null;
    englishVersionFileName: string | null;
}

export enum PolicyStatus {
    Draft = 1,
    Active = 2,
    Archived = 3,
}

export const policyStatusTranslationKeys: Record<PolicyStatus, string> = {
    [PolicyStatus.Draft]: "draft",
    [PolicyStatus.Active]: "active",
    [PolicyStatus.Archived]: "archived",
};

export interface PolicyListRowModel {
    id: string;
    userFriendlyId: number;
    name: string;
    description: string | null;
    responsible: BaseViewModel | null;
    approver: BaseViewModel | null;
    publishedAt: string | null;
    type: PolicyType;
    version: PolicyVersionStatus | null;
    sections: number;
    controls: number;
    receiptsCompleted: number;
    receiptsTotal: number;
    currentVersionReceiptsCompleted: number;
    currentVersionReceiptsTotal: number;
    status: PolicyStatus;
    unarchiveStatus: PolicyStatus;
    tags: Array<string>;
}

export interface PolicyVersionStatus {
    version: string;
    isInitialDraft: boolean;
}

export interface PolicyFilterResultViewModel {
    policies: Array<PolicyListRowModel>;
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

export interface PolicyTableRequest {
    filter: PolicyFilterRequest;
    displayColumns: Array<string>;
}

export interface PolicyExportHeader {
    header: string;
    column: string;
}
